import React from 'react';
import NumberFormat from 'react-number-format';
import {
  Card,
  Checkbox,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  Typography
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { calculatingTotalStorePrice } from 'helpers/priceCalculations';


const ListBullet = withStyles({
  root: {
    padding: '3px 0',

    '& .MuiListItem-root': {
      position: 'relative',
      paddingTop: '3px',
      paddingBottom: '3px'
    },

    '& .MuiListItem-root::before': {
      content: '" "',
      display: 'inline-block',
      position: 'absolute',
      left: '6px',
      width: '4px',
      height: '4px',
      backgroundColor: '#3C4257',
      borderRadius: '50%',
      marginRight: '10px'
    }
  }
})(List);

const StepTwo = ({values, storePriceSettings, setFieldValue}) => {
  const { information, price, discount } = storePriceSettings;
  const { profile } = useSelector((state) => state.user);
  const couponCode = profile?.onboarding?.couponCode;

  const {oneTime, monthly} = calculatingTotalStorePrice(price?.options, discount?.options, values.selectedDiscountsIds, couponCode);

  const handleChangeDiscount = (event) => {
    const {checked, name} = event.target;

    if (checked) {
      setFieldValue('selectedDiscountsIds', [...values.selectedDiscountsIds, name]);
    } else {
      setFieldValue('selectedDiscountsIds', values.selectedDiscountsIds.filter((id) => id !== name));
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={3}>
        <Typography variant="h4" component="h4" className="h4 mb-5">
          Base Store Setup
        </Typography>
      </Grid>
      <Grid item xs={12} md={9}>
        <Card elevation={25} className="p-5 mb-5">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6">{information?.title}</Typography>
              <ListBullet>
                {information?.options && information.options.map((option) => (
                  <ListItem key={option._id}>{option.label}</ListItem>
                ))}
              </ListBullet>
            </Grid>
          </Grid>
        </Card>
        <Card elevation={25} className="p-5 mb-5">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6">{price?.title}</Typography>
              <ListBullet>
                {price?.options && price.options.map((option, index) => (
                  <ListItem key={`store-option-${index}`} className="flex items-center justify-between w-full">
                    <span>{option.label}</span>
                    <NumberFormat
                      value={option.price}
                      displayType="text"
                      thousandSeparator={','}
                      decimalSeparator={'.'}
                      prefix={'+$'}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </ListItem>
                ))}
              </ListBullet>
            </Grid>
          </Grid>
        </Card>
        {(couponCode?.discountOneTime > 0 || couponCode?.discountMonthly > 0) &&
        <Card elevation={25} className="p-5 mb-5">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6">Referral Discount</Typography>
              <ListBullet>
                {couponCode.discountOneTime > 0 &&
                <ListItem className="flex items-center justify-between w-full">
                  <span>Store Setup discount</span>
                  <NumberFormat
                    value={couponCode.discountOneTime}
                    displayType="text"
                    thousandSeparator={','}
                    decimalSeparator={'.'}
                    prefix={'-$'}
                    fixedDecimalScale
                    decimalScale={2}
                  />
                </ListItem>}
                {couponCode.discountMonthly > 0 &&
                <ListItem className="flex items-center justify-between w-full">
                  <span>Monthly discount</span>
                  <NumberFormat
                    value={couponCode.discountMonthly}
                    displayType="text"
                    thousandSeparator={','}
                    decimalSeparator={'.'}
                    prefix={'-$'}
                    fixedDecimalScale
                    decimalScale={2}
                  />
                </ListItem>}
              </ListBullet>
            </Grid>
          </Grid>
        </Card>}
        {!!discount?.options.length &&
          <Card elevation={25} className="p-5 mb-5">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h6">{discount?.title}</Typography>
                {discount?.options && discount.options.map((option) => (
                  <FormControlLabel
                    key={option._id}
                    control={
                      <Checkbox
                        size="small"
                        name={option._id}
                        color="primary"
                        checked={values.selectedDiscountsIds.includes(option._id)}
                        onChange={handleChangeDiscount}
                      />
                    }
                    className="w-full"
                    label={
                      <div className="flex items-center justify-between">
                        <div>{option.label}</div>
                        <NumberFormat
                          value={option.price}
                          displayType="text"
                          thousandSeparator={','}
                          decimalSeparator={'.'}
                          prefix={'-$'}
                          fixedDecimalScale
                          decimalScale={2}
                        />
                      </div>
                    }
                  />
                ))}
              </Grid>
            </Grid>
          </Card>
        }
        <Card elevation={25} className="p-5 mb-5 bg-light-blue">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" className="uppercase">total</Typography>
              <ListBullet>
                <ListItem className="flex items-center justify-between w-full">
                  <span>Store Setup Fee</span>
                  <NumberFormat
                    value={oneTime}
                    displayType="text"
                    thousandSeparator={','}
                    decimalSeparator={'.'}
                    prefix={'$'}
                    fixedDecimalScale
                    decimalScale={2}
                    className="font-bold"
                  />
                </ListItem>
                <ListItem className="flex items-center justify-between w-full">
                  <span>Monthly Subscription Cost</span>
                  <NumberFormat
                    value={monthly}
                    displayType="text"
                    thousandSeparator={','}
                    decimalSeparator={'.'}
                    prefix={'$'}
                    fixedDecimalScale
                    decimalScale={2}
                    className="font-bold"
                  />
                </ListItem>
              </ListBullet>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default StepTwo;
